export const CREATE_PARTY: string = "Create Party";
export const CREATE_DOMAIN: string = "Create Domain";
export const CREATE_CHANNEL: string = "Create Channel";
export const MANAGE_PARTY: string = "Manage Party";
export const PARTY_NAME: string = "Party Name";
export const DOMAIN_NAME: string = "Domain Name";
export const CHANNEL_NAME: string = "Channel Name";
export const DESCRIPTION: string = "Description";
export const PARTY_TYPE: string = "Party Type";
export const ADDRESS: string = "Address";
export const NO_OF_DOMAINS: string = "No. of Domains";
export const NO_OF_CHANNEL: string = "No. of Channels";
export const NO_OF_ENVIRONMENT: string = "No. of Environment";
export const CREATED_ON: string = "Created On";

export const CREATE_PARTY_PERMISSION_MESSAGE = "You don't have permission to create the Party.";
export const UPDATE_PARTY_PERMISSION_MESSAGE = "You don't have permission to update the Party.";
export const DELETE_PARTY_PERMISSION_MESSAGE = "You don't have permission to delete the Party.";

export const CREATE_DOMAIN_PERMISSION_MESSAGE = "You don't have permission to create the Domain.";
export const UPDATE_DOMAIN_PERMISSION_MESSAGE = "You don't have permission to update the Domain.";
export const DELETE_DOMAIN_PERMISSION_MESSAGE = "You don't have permission to delete the Domain.";

export const CREATE_CHANNEL_PERMISSION_MESSAGE = "You don't have permission to create the Channel.";
export const UPDATE_CHANNEL_PERMISSION_MESSAGE = "You don't have permission to update the Channel.";
export const DELETE_CHANNEL_PERMISSION_MESSAGE = "You don't have permission to delete the Channel.";

export const CREATE_ENVIRONMENT_PERMISSION_MESSAGE = "You don't have permission to create the Environment.";
export const UPDATE_ENVIRONMENT_PERMISSION_MESSAGE = "You don't have permission to update the Environment.";
export const DELETE_ENVIRONMENT_PERMISSION_MESSAGE = "You don't have permission to delete the Environment.";

export const READ_PERMISSION: string = 'gmsadministration_read';
export const DELETE_PERMISSION: string = 'gmsadministration_delete';
export const CREATE_PERMISSION: string = 'gmsadministration_create';
export const UPDATE_PERMISSION: string = 'gmsadministration_update';
